export const TEMPLATES_DIALOG_WIDTH = 596;
